module.exports = __webpack_public_path__ + "img/New_Schedule_Table.128bff02.png";